import React, { useEffect, useState } from "react";
import "./Banner.css";

import img1 from "../../../Assets/Images/whalesai-new/comic.png";
// import img2 from "../../../Assets/Images/whalesai-new/consultant-ai.png";
import img3 from "../../../Assets/Images/developer-ai.png";
import img4 from "../../../Assets/Images/whalesai-new/image-ai.png";
import img5 from "../../../Assets/Images/news-video-ai.png";
import img6 from "../../../Assets/Images/whalesai-new/photo-post-ai.png";
import img7 from "../../../Assets/Images/post-ai.png";
import img8 from "../../../Assets/Images/whalesai-new/text-ai.png";
import img9 from "../../../Assets/Images/text-video-ai.png";
import img10 from "../../../Assets/Images/whalesai-new/toy_ai.png";
import img11 from "../../../Assets/Images/whalesai-new/voice_ai.png";
import img12 from "../../../Assets/Images/whalesai-new/photo-poster-ai.png";
import img13 from "../../../Assets/Images/whalesai-new/business-plan-ai.png";
import img14 from "../../../Assets/Images/whalesai-new/product-video-ai.png";
import img15 from "../../../Assets/Images/whalesai-new/facts-of-the-day-ai.png";
import img16 from "../../../Assets/Images/whalesai-new/marketing-poster-ai.png";
import img17 from "../../../Assets/Images/whalesai-new/video-ai.png";
import img18 from "../../../Assets/Images/whalesai-new/news-poster-ai.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/css";

import { useNavigate } from "react-router-dom";

const Banner = () => {
  const navigate = useNavigate();

  const images = [
    {
      img: img13,
      url: '/business-plan-ai',
    },
    {
      img: img1,
      url: '/comic-video-ai',
    },
    // {
    //   img: img2,
    //   url: '/social-media-consultant',
    // },
    {
      img: img15,
      url: '/fact-of-the-day-ai',
    },
    // {
    //   img: img3,
    //   url: '/developer-ai',
    // },
    {
      img: img4,
      url: '/image-ai',
    },
    {
      img: img16,
      url: '/promo-campaign-ai',
    },
    // {
    //   img: img5,
    //   url: '/news-video-ai',
    // },
    {
      img: img6,
      url: '/social-post-ai',
    },
    {
      img: img12,
      url: '/poster-design-ai',
    },
    {
      img: img14,
      url: '/product-video-ai',
    },
    // {
    //   img:img7,
    //   url:'/post-ai',
    // },
    {
      img: img8,
      url: '/text-ai',
    },
    // {
    //   img:img9,
    //   url:'/text-video-ai',
    // },
    {
      img: img10,
      url: '/toy-stories-ai',
    },
    {
      img: img11,
      url: '/voice-ai',
    },
    {
      img: img18,
      url: '/news-poster-ai',
    },
    {
      img: img17,
      url: '/video-ai',
    },
  ];

  return (
    <div className="banner-container">
      <div className="container banner-main row mx-auto px-4">

        {/* ================= DESKTOP ================= */}
        <div className="col-12 d-none d-md-block">
          <Swiper
            slidesPerView={2}
            spaceBetween={20}
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            className="mySwiper"
          >
            {images.map((item, index) => (
              <SwiperSlide key={index}>
                <img
                  onClick={() => navigate(item.url)}
                  className="img-fluid"
                  src={item.img}
                  alt="AI banner"
                  style={{ cursor: "pointer" }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* ================= MOBILE ================= */}
        <div className="col-12 d-md-none">
          <Swiper
            slidesPerView={1}
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            className="mySwiper"
          >
            {images.map((item, index) => (
              <SwiperSlide key={index}>
                <img
                  onClick={() => navigate(item.url)}
                  className="img-fluid"
                  src={item.img}
                  alt="AI banner"
                  style={{ cursor: "pointer" }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

      </div>
    </div>
  );
};

export default Banner;